export const ArrowRightSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.741 16.0554C13.3575 16.4529 13.3688 17.0859 13.7663 17.4694C14.1637 17.8529 14.7968 17.8416 15.1802 17.4442L18.8725 13.6176C19.4358 13.0339 19.4329 12.1081 18.8661 11.5279L15.0783 7.65041C14.6923 7.25534 14.0592 7.24794 13.6642 7.63386C13.2691 8.01979 13.2617 8.65292 13.6476 9.04798L16.1151 11.5739L6.42005 11.5739C5.86776 11.5739 5.42005 12.0216 5.42005 12.5739C5.42005 13.1262 5.86776 13.5739 6.42005 13.5739L16.1355 13.5739L13.741 16.0554Z"
        fill={props.fill || 'black'}
      />
    </svg>
  )
}
